export default __webpack_public_path__ + "static/media/vessels_ilustration_extra_large.8f6b6b22.jpg";